import React, { useContext } from 'react'
// import { useDispatch } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { UilMoneyWithdrawal } from '@iconscout/react-unicons'
import useSWR from 'swr'
import { Button } from '@mui/material'
import { RedemptionVaultContext } from '../context'


export default withTranslation()(function Header({ t, closeForm }) {
  const { data } = useSWR('accounts/balances')
  const { showForm, setShowForm } = useContext(RedemptionVaultContext)
  return (
    <div className="w-full flex bg-white p-4 md:p-10 flex-col lg:flex-row mb-10 rounded-xl">
      <div className="w-full mb-7 md:mb-0 grow">
        <div className="md:mr-16">
          <h4 className="text-lg font-semibold md:text-2xl text-[#05213D] font-[700]">NGN {data?.data?.find(x => x.type === 'reward')?.balance}   </h4>
          <p className="text-sm">{t('redemption.redemptiontitle')}</p>
        </div>
      </div>
      <div className='hidden'>
        <Button className='bg-primary text-white hover:text-primary w-[fit-content] py-2 px-5 border flex gap-[8px] rounded-[12px]'
          onClick={() => { setShowForm(!showForm) }}
        >
          <UilMoneyWithdrawal />  <p>Withdraw</p>
        </Button>
      </div>

    </div>
  )
})